import { PureComponent } from 'react';
import { Select } from 'antd';
import axios from 'axios';
import { requestWithAuth } from '../../services/api';

const { Option } = Select;
let source;

interface DataItem {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
}

interface DataSearchProps {
  id: string;
  placeholder: string;
  value: {
    key: number;
    label: string;
    value: number;
  } | null;
  onSelect: (data: DataItem) => void;
  onClear?: () => void;
  disabled?: boolean;
}

interface DataSearchState {
  data: DataItem[];
  loading: boolean;
}

class DataSearch extends PureComponent<DataSearchProps, DataSearchState> {
  constructor(props: DataSearchProps) {
    super(props);
    this.state = {
      data: [],
      loading: false,
    };
  }

  handleSearch = (value: string) => {
    if (value) {
      this.setState({ loading: true });
      const params = {
        is_user_map: 1,
        q: value,
      };
      const { id } = this.props;

      // if (controller) controller.abort();
      // controller = new AbortController(); // create a controller
      // const { signal } = controller; // grab a reference to its associated AbortSignal object using the AbortController.signal property

      if (source) source.cancel('Operation canceled by the user.');
      const { CancelToken } = axios; // eslint-disable-line import-x/no-named-as-default-member
      source = CancelToken.source();

      setTimeout(() => {
        requestWithAuth(id, 'GET', params, null, source.token)
          .then((response) => {
            if (response && response.results) {
              this.setState({ data: response.results, loading: false });
            } else {
              this.setState({ data: [], loading: false });
            }
          })
          .catch((e) => {
            this.setState({ data: [], loading: false });
            console.log(e);
          });
      }, 500);
    } else {
      this.setState({ data: [], loading: false });
    }
  };

  handleChange = (_: unknown, data: DataItem) => {
    const { onSelect } = this.props;
    if (onSelect) onSelect(data);
  };

  render() {
    const { data, loading } = this.state;
    return (
      <Select
        style={{ width: '100%' }}
        showSearch
        labelInValue
        loading={loading}
        value={this.props.value}
        placeholder={this.props.placeholder}
        defaultActiveFirstOption={false}
        showArrow={false}
        filterOption={false}
        onSearch={this.handleSearch}
        onChange={this.handleChange}
        notFoundContent={null}
        // isMulti
        // mode="multiple"
        allowClear
        disabled={this.props.disabled}
        onClear={this.props.onClear}
      >
        {data &&
          data.length > 0 &&
          data.map((item) => {
            return (
              <Option
                key={item.id}
                first_name={item.first_name}
                last_name={item.last_name}
                email={item.email}
              >
                <div className="select-class">
                  <div>{item.email}</div>
                  <div className="sub-option">
                    {item.first_name || ''} {item.last_name || ''}
                  </div>
                </div>
              </Option>
            );
          })}
      </Select>
    );
  }
}
export default DataSearch;
